// extracted by mini-css-extract-plugin
module.exports = {"box":"Minter_box__mEwVP","button":"Minter_button___MbON"};